import React, { useEffect, useRef } from 'react';
import { useState } from 'react';
import MessageInfo from '../../common/MessageInfo';
import PrematchContext from '../../contexts/PrematchContext';
import PrematchHomeContext from '../../contexts/PrematchHomeContext';
import { LIST_BETS_HANDICAP_TYPES, MAX_COLUMNS } from '../../data/constants';
import { classIf, filterBetsByNumberOfOdds, filterMatchesByTimestamp, filterSearchResults, filtraParametriche, getConfiguration, getLocaleTimestamp, getPrematchAggs, groupEventsByDate } from '../../data/utils';
import { getLabel } from '../../InitData';
import { CustomCols } from '../../live/Live';
import { useUISettings } from '../../UISettingsProvider';
import CompetitionOutrights from './CompetitionOutrights';
import CompetitionRanking from './CompetitionRanking';
import BetBuilderSection from './BetBuilderSection';
import PrematchBetGroupsNew from './PrematchBetGroupsNew';
import PrematchBetGroupsNewAlt from './PrematchBetGroupsNewAlt';
import PrematchTournamentDay from './PrematchTournamentDay';
import PrematchTournamentLiveMatches from './PrematchTournamentLiveMatches';

function showMatches(tournament) {
    const firstAggId = tournament.aggregate[0].idAggregata;
    const firstAgg = getPrematchAggs(tournament.sportRef, firstAggId);
    const noOdds = firstAgg.scommesse[0].odds.length === 0;
    return !(tournament.aggregate.length === 1 && noOdds);
}

function PrematchTournamentMatchContainer(props) {
    const prematchContext = React.useContext(PrematchContext);
    const customCols = React.useContext(CustomCols);
    const prematchHomeContext = React.useContext(PrematchHomeContext);
    const uiSettings = useUISettings();
    const tournament = props.tournament;
    const handledOpenFromPath = useRef(false);
    const conf = getConfiguration();
    const [section, setSection] = useState('events');

    function openSection(event, section) {
        event.preventDefault();
        setSection(section);
        if(section === 'betbuilder'){
        	prematchContext.setBetBuilderTournamentOpened(tournament.uniqueId);
        }
        else{
        	prematchContext.setBetBuilderTournamentOpened(null);
        }
    }

    useEffect(function() {
        // Se non è stato aperto un evento specifico da autocomplete
        if (tournament.events.length > 0 && prematchHomeContext?.match == null && section !== 'betbuilder') {
            // Se la URL path contiene le info per aprire il match
            const matchData = props.openFromPath?.match ?? null;
            if (!handledOpenFromPath.current && matchData) {
                handledOpenFromPath.current = true;
                const evento = tournament.events.find(e => {
                    return e.pal === parseInt(matchData.pal, 10) && e.avv === parseInt(matchData.avv, 10);
                });
                if (evento != null) {
                    prematchHomeContext?.changeMatch?.(evento);
                }
            } else { // apro il primo match del torneo corrente
                prematchHomeContext?.changeMatch?.(tournament.events[0]);
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [prematchHomeContext, tournament.events, section]);

    useEffect(() => {
        localStorage.removeItem('land-from-banner');
    }, []);

    let matches = tournament.events;
    // Se il è stato aperto un match tramite ricerca ed è attiva la modalità estesa, mostra solo il match aperto
    const showOnlySelectedMatch = conf?.otas === 'just_match' || prematchContext.match?.openedFromBanner;
    if (showOnlySelectedMatch && prematchContext.match && (prematchContext.match.openedFromBanner || uiSettings.fullScreen) && section !== 'betbuilder') {
        // const match = prematchContext.match;
        // const tournamentUniqueId = `${match.sportRef}_${match.categoryRef}_${match.tournamentRef}`;
        // if (tournamentUniqueId === tournament.uniqueId) {
        // }
        const m = tournament.events.find(m => m.id === prematchContext.match.id);
        matches = m ? [m] : [];
    }
    if (props.filter != null) {
        matches = filterSearchResults(tournament.events, props.filter, 'MATCH', function(match) {
            return match.desc;
        });
    }

    let bets = [];
    let headerBets = [];
    if (matches.length > 0) {
        const matchBets = matches[0].bets;
        bets = filtraParametriche(matchBets);
        bets = filterBetsByNumberOfOdds(bets, customCols);
        bets = bets.filter(bet => !LIST_BETS_HANDICAP_TYPES.includes(bet.tipoHandicap));
        if (matches[0].betsById.size === 0 && matchBets.length > 1) {
            headerBets = bets;
            let nOdds = 0;
            matchBets.forEach(bet => {
                nOdds += bet.odds.length;
            });
            if (nOdds > MAX_COLUMNS) {
                headerBets = [];
            }
        } else {
            headerBets = bets;
        }
    }

    matches = filterMatchesByTimestamp(matches, prematchContext.temporalFilter);
    const [dates, matchesByDate] = groupEventsByDate(matches);

    return (
        <React.Fragment>
            {(tournament.classifica || tournament.outrights.length > 0 || (tournament.betbuilder && conf.bbc?.en)) &&
                <div className="strumenti-competizione bg-grigio-4 bianco bordo-tondo d-flex flex-row align-items-center nav nav-tabs mb-1" role="tablist">
                    {showMatches(tournament) &&
                        <a className={"tasto-nav-filtri text-capitalize" + classIf(section === 'events', 'active')} href={`#filtro-${tournament.uniqueId}-p`} onClick={(e) => openSection(e, 'events')}>{getLabel('prematch_page.torneo.partite')}</a>
                    }
                    {tournament.classifica &&
                        <a className={"tasto-nav-filtri text-capitalize" + classIf(section === 'rankings', 'active')} href={`#filtro-${tournament.uniqueId}-c`} onClick={(e) => openSection(e, 'rankings')}>{getLabel('prematch_page.torneo.classifica')}</a>
                    }
                    {tournament.outrights.length > 0 &&
                        <a className={"tasto-nav-filtri text-capitalize" + classIf(section === 'outrights', 'active')} href={`#filtro-${tournament.uniqueId}-o`} onClick={(e) => openSection(e, 'outrights')}>{getLabel('prematch_page.torneo.outrights')}</a>
                    }
                    {tournament.betbuilder && conf.bbc?.en && 
                        <a className={"tasto-nav-filtri betbuilder-tab text-capitalize" + classIf(section === 'betbuilder', 'active')} href={`#filtro-${tournament.uniqueId}-bb`} onClick={(e) => openSection(e, 'betbuilder')}>{getLabel('betbuilder.title')}</a>
                    }
                </div>
            }
            <div className="tab-content" id={`tabellaCompetizione-${tournament.uniqueId}`}>
                {conf.iwh && section === 'events' &&
                    <div className="partite-del-giorno tab-pane fade overflow-visible show active">
                        <PrematchBetGroupsNewAlt macrogruppi={tournament.macrogruppi}
                                        macrogruppo={props.macrogruppo}
                                        changeMacrogruppo={props.changeMacrogruppo}
                                        aggregate={tournament.aggregate}
                                        aggregata={props.aggregata}
                                        changeAggregata={props.changeAggregata} />
                        {tournament.isLive &&
                            <PrematchTournamentLiveMatches data={props.data} tournament={props.tournament} openFromPath={props.openFromPath} />
                        }
                        <div className="contenitore-table-grande">
                            {matches.length > 0 ?
                                dates.map((date, dateIndex) =>
                                    <PrematchTournamentDay key={dateIndex} id={dateIndex} date={date} tournament={tournament} matches={matchesByDate[date]} bets={bets} headerBets={headerBets} aggregata={props.aggregata} />
                                )
                                :
                                <MessageInfo message={getLabel('general.no_events')} />
                            }
                        </div>
                    </div>
                }
                {!conf.iwh && section === 'events' &&
                    <div className="partite-del-giorno tab-pane fade overflow-visible show active">
                        <PrematchBetGroupsNew macrogruppi={tournament.macrogruppi}
                                        macrogruppo={props.macrogruppo}
                                        changeMacrogruppo={props.changeMacrogruppo}
                                        aggregate={tournament.aggregate}
                                        aggregata={props.aggregata}
                                        changeAggregata={props.changeAggregata} />
                        {tournament.isLive &&
                            <PrematchTournamentLiveMatches data={props.data} tournament={props.tournament} openFromPath={props.openFromPath} />
                        }
                        <div className="contenitore-table-grande">
                            {matches.length > 0 ?
                                dates.map((date, dateIndex) =>
                                    <PrematchTournamentDay key={dateIndex} id={dateIndex} date={date} tournament={tournament} matches={matchesByDate[date]} bets={bets} headerBets={headerBets} aggregata={props.aggregata} />
                                )
                                :
                                <MessageInfo message={getLabel('general.no_events')} />
                            }
                        </div>
                    </div>                            
                }
                {section === 'rankings' &&
                    <div className="tab-classifica tab-pane show active">
                        <CompetitionRanking descrizione={tournament.descrizione} classifica={tournament.classifica} sport={tournament.sportRef} />
                    </div>
                }
                {section === 'outrights' &&
                    <div className="tab-classifica tab-pane show active">
                        <CompetitionOutrights {...tournament} />
                    </div>
                }
                {section === 'betbuilder' &&
                    <div className="tab-classifica tab-pane show active">
                        <BetBuilderSection key={tournament.sportRef + "_" + tournament.id} tournament={tournament} data={props.data} />
                    </div>
                }
            </div>
        </React.Fragment>
    );
}

export default PrematchTournamentMatchContainer;
